export default __webpack_public_path__ + "static/media/BB_28.5e0e1ab1.png";